import React from 'react';
import { Server, Code, Database, Settings, Layers } from 'lucide-react';

/**
 * Компонент секции технических параметров
 */
const TechnicalParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  infrastructureTypes,
  customizationLevels
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Server className="w-5 h-5 mr-2 text-indigo-500" />
        Технические параметры
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Тип инфраструктуры */}
        <div>
          <label htmlFor="infrastructureType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Тип ИТ-инфраструктуры
          </label>
          <select
            id="infrastructureType"
            name="infrastructureType"
            value={formData.infrastructureType}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.infrastructureType ? 'input-error' : ''}`}
          >
            {infrastructureTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
          {errors.infrastructureType && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.infrastructureType}
            </p>
          )}
        </div>

        {/* Количество ИИ-решений */}
        <div>
          <label htmlFor="aiSolutionsCount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Количество ИИ-решений
          </label>
          <input
            type="text"
            id="aiSolutionsCount"
            name="aiSolutionsCount"
            value={formData.aiSolutionsCount}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.aiSolutionsCount ? 'input-error' : ''}`}
            placeholder="Например: 3"
          />
          {errors.aiSolutionsCount && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.aiSolutionsCount}
            </p>
          )}
        </div>

        {/* Существующая инфраструктура */}
        <div>
          <label htmlFor="existingInfrastructureLevel" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Уровень существующей инфраструктуры
          </label>
          <select
            id="existingInfrastructureLevel"
            name="existingInfrastructureLevel"
            value={formData.existingInfrastructureLevel}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            <option value="minimal">Минимальный</option>
            <option value="moderate">Умеренный</option>
            <option value="substantial">Существенный</option>
          </select>
        </div>

        {/* Уровень кастомизации */}
        <div>
          <label htmlFor="customizationLevel" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Уровень кастомизации решений
          </label>
          <select
            id="customizationLevel"
            name="customizationLevel"
            value={formData.customizationLevel}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.customizationLevel ? 'input-error' : ''}`}
          >
            {customizationLevels.map((level) => (
              <option key={level.id} value={level.id}>
                {level.name}
              </option>
            ))}
          </select>
          {errors.customizationLevel && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.customizationLevel}
            </p>
          )}
        </div>

        {/* Пояснения по техническим параметрам */}
        <div className="col-span-full bg-white dark:bg-gray-700/50 rounded-lg p-3 mt-2 border border-gray-200 dark:border-gray-700">
          <div className="flex items-start gap-3">
            <div className="mt-0.5">
              <Layers className="w-5 h-5 text-indigo-500" />
            </div>
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">Технические параметры влияют на стоимость</h4>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1 text-xs text-gray-600 dark:text-gray-400">
                <div className="flex items-center gap-1.5">
                  <Server className="w-3.5 h-3.5 text-blue-500" />
                  <span><strong>Облачная инфраструктура</strong> — ниже начальные затраты</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <Database className="w-3.5 h-3.5 text-blue-500" />
                  <span><strong>Локальная инфраструктура</strong> — выше начальные затраты</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <Code className="w-3.5 h-3.5 text-purple-500" />
                  <span><strong>Кастомизация</strong> — влияет на стоимость внедрения</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <Settings className="w-3.5 h-3.5 text-purple-500" />
                  <span><strong>Количество решений</strong> — влияет на сложность</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechnicalParametersSection;